module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-960f98.53f52c42.png";